import styled from 'styled-components';
import { PrimaryColor, DarkGreySidely, GreySidely3, RedSidely } from '../../../styles/global/css/Utils';

export const Body = styled.div`
	padding: 0 5%;
	display: flex;
	flex-direction: column;
	gap: 24px;
	overflow: auto;
	height: calc(100% - 90px);
`;

export const Hint = styled.p`
	margin: 0;
	font-size: 12px;
	color: ${GreySidely3};
`;

export const SectionTitle = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 14px;
	font-weight: 600;
	color: ${DarkGreySidely};
	margin-bottom: 8px;
`;

export const Grid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(96px, 1fr));
	gap: 8px;
`;

export const Thumb = styled.div<{ background: string }>`
	position: relative;
	aspect-ratio: 1;
	border-radius: 6px;
	background: #f2f2f2 url(${p => p.background}) center / contain no-repeat;
	cursor: zoom-in;
	border: 1px solid #e6e6e6;

	&:hover > button {
		opacity: 1;
	}
`;

export const ThumbDelete = styled.button`
	position: absolute;
	top: 4px;
	right: 4px;
	width: 24px;
	height: 24px;
	border: none;
	border-radius: 12px;
	background: white;
	color: ${RedSidely};
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	opacity: 0;
	transition: opacity 0.2s ease;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
`;

export const Empty = styled.div`
	font-size: 13px;
	color: ${GreySidely3};
	padding: 12px;
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
`;

/** The camera next to a product name in vision mode. */
export const VisionOpen = styled.span`
	display: inline-flex;
	align-items: center;
	margin-left: 6px;
	vertical-align: middle;
	cursor: pointer;
	color: ${PrimaryColor};
`;

export const ToolbarToggle = styled.label`
	display: flex;
	align-items: center;
	gap: 6px;
	margin-left: 10px;
	font-size: 13px;
	color: ${DarkGreySidely};
	white-space: nowrap;
	cursor: pointer;
`;
